import {
  CategoriesPage,
  Category,
  CategoryStatus,
  NewCategory,
} from '../../models/categories';
import AccountingApiClient from './base-client';

class CategoriesApi extends AccountingApiClient<Category, CategoriesPage> {
  public constructor() {
    super('/categories');
  }

  public async getPage({
    page = 1,
    perPage = null,
    search,
  }: {
    page: number;
    perPage: number | null;
    search: string;
  }): Promise<CategoriesPage> {
    let url = `${this.baseUrl}?page=${page}`;
    if (perPage !== null) {
      url = `${url}&per_page=${perPage}`;
    }
    url = `${url}&filter=status eq '${CategoryStatus.ACTIVE}'`;
    if (search) {
      url = `${url}&search=${search}`;
    }
    return super.httpList(url);
  }

  public async get(id: string): Promise<Category> {
    return super.httpGet(`${this.baseUrl}/${id}`);
  }

  public async create(category: NewCategory): Promise<Category> {
    return super.httpPost<NewCategory>(this.baseUrl, category);
  }

  public async update(
    category: Partial<Category> & { id: string }
  ): Promise<Category> {
    const { id, ...body } = category;
    return super.httpPut(`${this.baseUrl}/${id}`, body);
  }

  public async delete(id: string): Promise<void> {
    return super.httpDelete(`${this.baseUrl}/${id}`);
  }
}

const categoriesApi = new CategoriesApi();

export default categoriesApi;
